import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import type {
  WeightDriftResponse,
  AlertsResponse,
  MaterialQualityResponse,
  InSpecTrendResponse,
  InspectorConsistencyResponse,
} from "@shared/types";

export function useWeightDrift(product: string) {
  return useQuery({
    queryKey: ["analytics", "strength-model", product],
    queryFn: () =>
      apiFetch<WeightDriftResponse>("/api/analytics/strength-model", { product }),
    enabled: !!product,
    staleTime: 10 * 60 * 1000,
  });
}

export function useMaterialQuality(
  product: string,
  material: string,
  test: string,
  from: string,
  to: string
) {
  return useQuery({
    queryKey: ["analytics", "material-quality", product, material, test, from, to],
    queryFn: () =>
      apiFetch<MaterialQualityResponse>("/api/analytics/material-quality", {
        product,
        material,
        test,
        from,
        to,
      }),
    enabled: !!product && !!material,
    staleTime: 5 * 60 * 1000,
  });
}

export function useAlertsSummary(from: string, to: string) {
  return useQuery({
    queryKey: ["analytics", "alerts", from, to],
    queryFn: () => apiFetch<AlertsResponse>("/api/analytics/alerts", { from, to }),
    staleTime: 5 * 60 * 1000,
  });
}

export function useInSpecTrend(
  product: string,
  test: string,
  from: string,
  to: string,
  bucket: "week" | "month" = "week"
) {
  return useQuery({
    queryKey: ["analytics", "in-spec-trend", product, test, from, to, bucket],
    queryFn: () =>
      apiFetch<InSpecTrendResponse>("/api/analytics/in-spec-trend", {
        product,
        test,
        from,
        to,
        bucket,
      }),
    enabled: !!product,
    staleTime: 5 * 60 * 1000,
  });
}

export function useInspectorConsistency(
  product: string,
  test: string,
  from: string,
  to: string
) {
  return useQuery({
    queryKey: ["analytics", "inspector-consistency", product, test, from, to],
    queryFn: () =>
      apiFetch<InspectorConsistencyResponse>("/api/analytics/inspector-consistency", {
        product,
        test,
        from,
        to,
      }),
    enabled: !!product,
    staleTime: 5 * 60 * 1000,
  });
}
